<script lang="ts">
    import { clickEnter } from "@utils/directives/accessibility"
    import { createEventDispatcher } from "svelte"
    import { twMerge } from "tailwind-merge"
    export let label = "switch"
    export let toggled: boolean = false
    export let disabled = false
    const dispatch = createEventDispatcher()
    export let className: string = ""
    $: disabledClasses = disabled ? "opacity-80 grayscale" : ""
    export { className as class }
</script>

<div
    on:keydown={clickEnter}
    aria-label={label}
    style:border-radius="2em"
    tabindex={disabled ? -1 : 0}
    role="switch"
    aria-disabled={disabled}
    aria-checked={toggled}
    class={twMerge(disabledClasses, className)}
    {...$$restProps}
    on:click={() => {
        if (!disabled) {
            toggled = !toggled
            dispatch(toggled ? "on" : "off")
        }
    }}
>
    <svg xmlns="http://www.w3.org/2000/svg" style:height="2em" viewBox="0 9 48 30">
        <g>
            <g class="js-nc-int-icon nc-int-switcher" class:nc-int-icon-state-b={toggled}>
                <rect fill="#c8c8c8" height="26" rx="13" ry="13" width="44" x="2" y="11" />
                <circle cx="15" cy="24" fill="#fff" r="11" />
            </g>
        </g>
    </svg>
</div>

<style lang="postcss">
    .nc-int-switcher {
        --transition-duration: 0.3s;
    }

    .nc-int-switcher :first-child {
        fill: #c8c8c8;
        transition: fill var(--transition-duration);
    }

    .nc-int-switcher :last-child {
        transition: transform var(--transition-duration) cubic-bezier(0.77, 0, 0.18, 1);
    }

    .nc-int-switcher.nc-int-icon-state-b :first-child {
        @apply opacity-60 fill-purple-900;
    }

    .nc-int-switcher.nc-int-icon-state-b :last-child {
        transform: translateX(18px);
    }
</style>
